export default {
  init(vue) {
    return {
      resendOrderGift(oid) {
        return vue.$http({
          method: 'GET',
          url: `/pages/order/resendOrderGift`,
          params: {
            orderId: oid
          }
        })
      },
      logSearch(data) {
        return vue.$http({
          method: 'GET',
          url: `/bas/pages/log/search`,
          params: {
            ...data
          }
        })
      },
      pagesLogSearch(data) {
        return vue.$http({
          method: 'GET',
          url: `/pages/order/log/search`,
          params: {
            ...data
          }
        })
      },
      sendOrderGoods(data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/order/sendOrderGoods`,
          data: data
        })
      },
      updateOrderStatus(data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/order/updateOrderStatus`,
          data: data
        })
      },
      /**
       * 渠道退款
       * @param {"orderId":2735067, "memo":"用户未到账退还费用"} data 
       * @returns 
       */
      cancelChannelFee(data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/order/cancelChannelFee`,
          data: data
        })
      },
      createCardOrder(data) {
        const formdata = new FormData();
        Object.keys(data).forEach(key => {
          formdata.append(key, data[key]);
        })
        return vue.$http({
          method: 'POST',
          url: `/pages/order/createCardOrder`,
          data: formdata,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      },
      /**
       * dataType:不传为号卡
       * order  普通订单
       * recharge  话费充值订单手机号
       * errorOrder  失败订单手机号
       * xxl  信息流
       */
      queryPlaintext(data) {
        return vue.$http({
          method: 'POST',
          // url: `/pages/card/queryPlaintext`,
          url: `/pages/common/queryPlaintext`,
          data: data
        })
      },
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/order.service.js